import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  // Fetch credit balance
  creditsFetchRequest: ['callback'],
  creditsFetchSuccess: ['credits', 'costs'],
  creditsFetchFailure: ['error'],

  // Preview cost before action
  creditsPreviewRequest: ['scenesCount', 'animate', 'callback'],
  creditsPreviewSuccess: ['preview'],
  creditsPreviewFailure: ['error'],

  // Check if action is affordable
  creditsCheckRequest: ['actionType', 'count', 'callback'],
  creditsCheckSuccess: ['canAfford', 'required', 'available'],
  creditsCheckFailure: ['error'],

  // Fetch credit history
  creditsHistoryRequest: ['params', 'callback'],
  creditsHistorySuccess: ['history', 'totalCount'],
  creditsHistoryFailure: ['error'],

  // Clear credits (on logout)
  creditsClear: null,
})

export const CreditTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const INITIAL_STATE = {
  // Credit balance
  credits: null,
  costs: null,
  
  // Preview
  preview: null,
  previewFetching: false,
  
  // History
  history: [],
  historyTotalCount: 0,
  historyFetching: false,
  
  // General
  fetching: false,
  error: null,
}

/* ------------- Selectors ------------- */

export const CreditSelectors = {
  getCredits: state => state.credits.credits,
  getCosts: state => state.credits.costs,
  getAvailableCredits: state => state.credits.credits?.available || 0,
  isLowCredits: state => {
    const available = state.credits.credits?.available || 0
    const total = state.credits.credits?.total || 1
    return available / total < 0.2 // Less than 20%
  },
  getHistory: state => state.credits.history,
  isFetching: state => state.credits.fetching,
}

/* ------------- Reducer ------------- */

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Fetch credits
    case Types.CREDITS_FETCH_REQUEST:
      return { ...state, fetching: true, error: null }
    case Types.CREDITS_FETCH_SUCCESS:
      return { ...state, fetching: false, credits: action.credits || null, costs: action.costs || null, error: null }
    case Types.CREDITS_FETCH_FAILURE:
      return { ...state, fetching: false, error: action.error }

    // Preview cost
    case Types.CREDITS_PREVIEW_REQUEST:
      return { ...state, previewFetching: true, error: null }
    case Types.CREDITS_PREVIEW_SUCCESS:
      return { ...state, previewFetching: false, preview: action.preview || null, error: null }
    case Types.CREDITS_PREVIEW_FAILURE:
      return { ...state, previewFetching: false, error: action.error }

    // Check affordability
    case Types.CREDITS_CHECK_REQUEST:
      return { ...state, error: null }
    case Types.CREDITS_CHECK_SUCCESS:
      return { ...state, error: null }
    case Types.CREDITS_CHECK_FAILURE:
      return { ...state, error: action.error }

    // History
    case Types.CREDITS_HISTORY_REQUEST:
      return { ...state, historyFetching: true, error: null }
    case Types.CREDITS_HISTORY_SUCCESS:
      return { ...state, historyFetching: false, history: action.history || [], historyTotalCount: action.totalCount, error: null }
    case Types.CREDITS_HISTORY_FAILURE:
      return { ...state, historyFetching: false, error: action.error }

    // Clear
    case Types.CREDITS_CLEAR:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
